import React from 'react'

import { VariantSetProperty } from '../../../../../../inspector'
import {
  AttributeList,
  CollapsibleInspectorSection,
  FullCopyAttribute,
} from '../../components'

interface VariantSetProps {
  /**
   * The variant properties the variant set defines. Optional/possibly empty for
   * plain sections that are not variant sets — the components render nothing.
   */
  properties: VariantSetProperty[] | undefined
}

/**
 * Renders a variant set's property definitions (e.g. Type=Primary, Secondary,
 * Destructive) as copiable attribute rows: each property key with its full list
 * of possible values.
 */
export const VariantSetRows: React.FCC<VariantSetProps> = ({ properties }) => (
  <AttributeList data-testid="inspector-sidebar-variant-set">
    {(properties ?? []).map(({ id, name, values }) => (
      <FullCopyAttribute
        key={id}
        label={name}
        value={values.map(value => value.name).join(', ')}
      />
    ))}
  </AttributeList>
)

/**
 * A dedicated inspector section listing the variant properties a variant set
 * (Section) defines. Renders nothing for sections without variant properties.
 */
export const VariantSetSection: React.FCC<VariantSetProps> = ({
  properties,
}) => {
  if (!properties?.length) {
    return null
  }

  return (
    <CollapsibleInspectorSection
      identifier="variant-set"
      title="Variant Set"
      data-testid="inspector-sidebar-variant-set-section"
    >
      <VariantSetRows properties={properties} />
    </CollapsibleInspectorSection>
  )
}
